var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar is-dark",
    attrs: {
      "role": "navigation",
      "aria-label": "main navigation"
    }
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    class: {
      'is-active': _vm.$route.name == 'Vote'
    },
    attrs: {
      "tag": "a",
      "to": {
        name: 'Vote'
      },
      "exact": ""
    }
  }, [_vm._v("\n      Vote\n    ")])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33d51899","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 0MEn
// module chunks = 1